<template>
    <div>
        <slot></slot>
    </div>
</template>

<script>
import _ from 'underscore';
export default {
    components: {},
    computed: {
        community() {
            return this.$store.getters.community;
        },
    },
    mounted: function () {
        this.$store
            .dispatch('fetchCommunity', this.$route.params.communityId)
            .then(() => {
                this.$store
                .dispatch('fetchCommunityMetadata', this.$route.params.communityId)
                .catch((e) => {
                    console.error('failed to fetch community pending data');
                });
            })
            .catch((e) => {
                console.error('failed to fetch community');
                this.$router.push('/communities');
            });
        
    },
    methods: {},
};
</script>

<style></style>
